var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4590_160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4590_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2 41.4666L44.2667 26.3999L40.4667 22.5999L29.2 33.8666L23.6 28.2666L19.8 32.0666L29.2 41.4666ZM32 58.6666C25.8222 57.111 20.7222 53.5666 16.7 48.0333C12.6778 42.4999 10.6667 36.3555 10.6667 29.5999V13.3333L32 5.33325L53.3334 13.3333V29.5999C53.3334 36.3555 51.3222 42.4999 47.3 48.0333C43.2778 53.5666 38.1778 57.111 32 58.6666ZM32 53.0666C36.6222 51.5999 40.4445 48.6666 43.4667 44.2666C46.4889 39.8666 48 34.9777 48 29.5999V16.9999L32 10.9999L16 16.9999V29.5999C16 34.9777 17.5111 39.8666 20.5334 44.2666C23.5556 48.6666 27.3778 51.5999 32 53.0666Z",
    fill: "#1D8145"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.462b689745adf2f0ceb0380d72021966.svg";
export { ForwardRef as ReactComponent };